/*
 * Custom blog pagination.
 * Foreach numbered ajax pagination we add events and on click we fetch the next page.
 */

const getParams = (paged, moduleID) => {
	const settings = pagination_settings.modules[moduleID];
	return {
		buttonSelector: settings.buttonSelector,
		node: moduleID,
		pageNumber: paged,
		paginationNumbers: settings.paginationNumbers,
		postID: settings.postID,
		postPerPage: settings.postPerPage,
		postsContainer: settings.postsContainer,
	};
};

const loadPosts = (params) => {
	$.ajax({
		type: 'POST',
		dataType: 'html',
		url: pagination_settings.ajax_url,
		data: params,
		success: (data) => {
			if (!data || data === pagination_settings.no_more_posts) {
				$(params.buttonSelector).show();
				return;
			}

			const posts = $(data);
			if (posts.length) {
				$(params.postsContainer).empty();
				$(params.postsContainer).append(posts);
			}

			// Trigger a browser resize event
			$(window).trigger('resize');
		},
		error: (jqXHR, textStatus, errorThrown) => {
			// Remove post page loader.
			$(pagination_settings.page_loader.selector).remove();
			// eslint-disable-next-line no-console
			console.log(`${jqXHR} :: ${textStatus} :: ${errorThrown}`);
		},
	});
	return false;
};

const loadPagination = (params) => {
	$(params.paginationNumbers).hide();

	$.ajax({
		type: 'POST',
		dataType: 'html',
		url: pagination_settings.pagination_url,
		data: params,
		success: (data) => {
			$(pagination_settings.page_loader.selector).remove();
			const updatedData = data.replace(/\?action=load_pagination/g, '');
			$(params.paginationNumbers).html(updatedData);
			$(params.paginationNumbers).show();
		},
		error: (jqXHR, textStatus, errorThrown) => {
			// Remove post page loader.
			$(pagination_settings.page_loader.selector).remove();
			// eslint-disable-next-line no-console
			console.log(`${jqXHR} :: ${textStatus} :: ${errorThrown}`);
		},
	});
};

document.addEventListener('DOMContentLoaded', () => {
	$('.fl-builder-pagination').find('.page-numbers.prev').html('Prev');
	$('.fl-builder-pagination').find('.page-numbers.next').html('Next');
	$('.fl-builder-pagination.is-ajax').each(function () {
		const currentPagination = $(this);
		const moduleID = $(this).closest('.fl-module.fl-module-post-grid').data('node');
		$(this).on('click', (event) => {
			event.preventDefault();
			event.stopPropagation();

			if ($(event.target).hasClass('page-numbers') && $(event.target).is('a')) {
				const href = $(event.target).attr('href');
				// Match the page.
				const paged = href.match(/(page|paged)[^/]*\/(\d+)/)[2] || 1;

				const params = getParams(paged, moduleID);

				// Append posts page loader.
				$(currentPagination).append(pagination_settings.page_loader.html);
				loadPosts(params);
				loadPagination(params);
			}
		});
	});
});
